import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import Card from "@/components/UI/Card/Card";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section12Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const SocialSection = ({ className, job, page, section, ...props }: Section12Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.SocialCards?.length > 0 && (
          <div className="flex flex-col gap-10 lg:flex-row">
            {section?.SocialCards?.map((card: any) => {
              return (
                <Card className="flex flex-1 flex-col divide-y rounded-md" key={card?.id}>
                  <div className="flex flex-1 flex-col gap-4 p-6">
                    <div className="flex gap-4">
                      {card?.Image?.data?.attributes && (
                        <div>
                          <Image
                            alt={card?.Image?.data?.attributes?.alternativeText}
                            className="w-12 rounded-full"
                            src={card?.Image?.data?.attributes?.url}
                            width={card?.Image?.data?.attributes?.width ?? "100"}
                            height={card?.Image?.data?.attributes?.height ?? "100"}
                          />
                        </div>
                      )}
                      <div>
                        {card?.Title && <div>{card?.Title}</div>}
                        {card?.Subtitle && <div className="text-xs text-vpGray-700">{card?.Subtitle}</div>}
                      </div>
                    </div>
                    {card?.Body && <div>{card?.Body}</div>}
                  </div>
                  {card?.Underline && (
                    <div className="flex items-center gap-2 px-6 py-2">
                      <div className="text-vpGray-700">{card?.Underline}</div>
                    </div>
                  )}
                </Card>
              );
            })}
          </div>
        )}
        {section?.Button && (
          <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
            <Button className="mx-auto" size="large">
              {section?.Button?.Value}
            </Button>
          </Link>
        )}
      </SectionContainer>
    </Section>
  );
};

export default SocialSection;
